export const cartList = (cb) => {
    return (dispatch, getState, props) => {
        if(getState().cartReducer.cart)
            cb(getState().cartReducer.cart);
    };
};


